import { ICategoryState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Category from '../../classes/category';

const initialState: ICategoryState = {
  data: undefined,
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    updateCategories: (state, action: PayloadAction<Category[]>) => {
      state.data = action.payload;
    },
  },
});

const { actions, reducer: categoriesReducer } = categoriesSlice;
export const { updateCategories } = actions;
export const categoriesSelector = (state: RootState) => state.categories;
export default categoriesReducer;
